import React, { useState, useEffect } from "react";
import classes from "./truckcleaning.module.css";
import axios from "../../../../../../Axios";
import { Urls } from "../../../../../../Urls";
import Loader from "../../../../../Loader";
import { toast } from "react-toastify";
import { next_page, save_details_api } from "../../../../Utility";
import { Activity, currentRequestTimeStamp } from "../../../../../../Constants";
import mixpanel from "mixpanel-browser";

const TruckCleaning = ({
  step = 3,
  setStep = "",
  setPreviosStep = "",
  PreviosStep = 0,
  trucks = [],
  settrucks = "",
  excel_details = {},
  fetch_cleaning_details = "",
  fetch_saved_details = "",
  transporters = [],
  settransporter = "",
}) => {
  const [truckTypes, setTruckTypes] = useState([]);
  const [truck_details, setTruck_details] = useState([]);
  // const [transporter_details, setTransporter_details] = useState([])
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (
      excel_details &&
      excel_details.blob_url &&
      (PreviosStep === 0 || PreviosStep === 2)
    ) {
      fetch_cleaning_details(excel_details.blob_url, excel_details.excel_id);
    } else {
      fetch_saved_details(excel_details.excel_id);
    }
  }, [excel_details, PreviosStep]);

  useEffect(() => {
    setShow(true);
    getTruckTypes();
    // setTransporter_details(transporter)
  }, [trucks]);

  const getTruckTypes = () => {
    // console.log(trucks)
    axios
      .get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck`)
      .then((res) => {
        var temp = [];
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].network_truck_type_group) {
            if (
              temp.filter(
                (truck) => truck.label === res.data[i].network_truck_type_group
              ).length === 0
            ) {
              temp.push({
                label: res.data[i].network_truck_type_group,
                value: res.data[i].network_truck_type_group,
              });
            }
          }
          if (i === res.data.length - 1) {
            var temp1 = trucks.map((truck, index) => {
              if (truck.type === "matched") {
                truck.label = truck["truck_type_group"];
                truck.value = truck["truck_type_group"];
              } else {
                if (temp.length > 0) {
                  // console.log(temp)
                  temp.map((item) => {
                    if (item.label === truck["Truck"]) {
                      truck.label = item.label;
                      truck.value = item.value;
                    }
                  });
                }
              }
              if (index === trucks.length - 1) {
                setShow(false);
              }

              return truck;
            });
            // console.log(temp1)
            setTruck_details(temp1);
          }
        }
        setTruckTypes(temp);
        // console.log(truckTypes)
      })
      .catch((err) => {});
  };

  const selectTruck = (value, truck) => {
    var temp = truck_details.map((t) => {
      if (t.index === truck.index) {
        t.label = value;
        t.value = value;
      }
      return t;
    });
    setTruck_details(temp);
  };

  const check_truck = () => {
    for (var i = 0; i < truck_details.length; i++) {
      // console.log(truck_details[i])
      if (!truck_details[i].label || !truck_details[i].value) {
        // console.log('not found truck')
        return false;
      }
    }
    return true;
  };

  const save_Trucks = (trucks) => {
    setShow(true);
    var trk_spell = [],
      trk_matched = [];
    trucks.map((truck) => {
      truck["user_input"] = "accepted";
      if (truck.type === "matched") {
        trk_matched.push(truck);
      }
      if (truck.type === "spell") {
        trk_spell.push(truck);
      }
    });
    if (trk_spell && trk_spell.length > 0) {
      var payload = {
        data: trk_spell,
        key: "trk_spell",
        excel_id: excel_details.excel_id,
      };
      // console.log(payload)
      save_details_api(payload)
        .then((res) => {
          setShow(false);
          // save_details()
          // toast.success('Trucks Spell Saved')
        })
        .catch((e) => console.log(e));
    }
    if (trk_matched && trk_matched.length > 0) {
      var payload = {
        data: trk_matched,
        key: "trk_matched",
        excel_id: excel_details.excel_id,
      };
      // console.log(payload)
      save_details_api(payload)
        .then((res) => {
          setShow(false);
          // toast.success('Trucks Matched Saved')
        })
        .catch((e) => console.log(e));
    }
  };

  const go_to_confirmpage = () => {
    Activity([
      {
        screen: "Truck-type Cleaning",
        module: "My Freight Benchmark",
        user_activity: `Truck type Screen: User clicked on Next Button`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(
      `Benchmark Truck type Screen: User has clicked on Next Button`,
      {
        ApplicationName: `${Urls.mixpanelappname}`,
        ScreenName: "LoRRI-Benchmark",
        ModuleName: "edit_page",
        ActivityLog: `UserHasClickedOnNextButton`,
        Data: `None`,
        Definition: `Benchmark Truck type Screen: User has clicked on Next Button`,
        ActivityType: "event_view",
        UserName: `${localStorage.getItem("userdetails")}`,
        UserEmail: `${localStorage.getItem("useremail")}`,
        CompanyName: `${localStorage.getItem("companyname")}`,
      }
    );
    if (!check_truck()) {
      toast.info("Please select the corresponding truck type from dropdown");
    } else {
      save_Trucks(truck_details);
      next_page({
        data: "confirmlanes",
        excel_id: excel_details.excel_id,
        key: "page",
      });
      setStep(4);
    }
  };

  const cancelProcess = () => {
    if (window.confirm("Are you sure to cancel?")) {
      next_page({
        data: "completed",
        excel_id: excel_details.excel_id,
        key: "page",
      }); //Imp
      document.getElementById("close_contactus1").click();
      toast.success("Process Cancelled Successfully");
    }
  };

  return (
    <div>
      <div className={`row`}>
        <div className={`col-md-12`}>
          <Loader show={show} />
          {/* Check Truck Types */}
          <div className={classes["trucks_header"]}>
            <div className={classes["truck_type"]}>Unique Trucks</div>
            <div className={classes["trucks_autocomplete"]}>
              Check Truck Type
            </div>
          </div>
          <div className={classes["trucks_details"]}>
            {truck_details && truck_details.length > 0 ? (
              truck_details.map((truck) => {
                return (
                  <div className={`${classes["trucks"]}`}>
                    <div className={classes["truck_type1"]}>
                      {truck["Truck"]}
                    </div>
                    <div className={classes["trucks_autocomplete"]}>
                      {/* <Select
                                        options={truckTypes}
                                        onChange={value => selectTruck(value)}
                                        value={truck}
                                        className={"Truck_type_Select"}
                                        classNamePrefix={"Truck_Prefix"}
                                        formatCreateLabel={() => ''}
                                    /> */}
                      <select
                        className="form-control"
                        onChange={(e) => selectTruck(e.target.value, truck)}
                      >
                        <option>Please select</option>
                        {/* {console.log(truckTypes)} */}
                        {truckTypes && truckTypes.length > 0
                          ? truckTypes.map((t) => {
                              return (
                                <option
                                  value={t.value}
                                  selected={t.value === truck.value}
                                >
                                  {t.label}
                                </option>
                              );
                            })
                          : null}
                      </select>
                      {!truck.label ||
                      !truck.value ||
                      truck.label === "" ||
                      truck.value === "" ? (
                        <label style={{ color: "red", fontSize: "10px" }}>
                          Please Select Truck Type form dropdown
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <span>No Trucks Found</span>
            )}
          </div>
        </div>
      </div>
      <center>
        <button
          className="btn btn-sm btn-danger mr-3"
          onClick={(e) => cancelProcess()}
        >
          Cancel
        </button>
        <button
          className="btn btn-sm btn-primary m-3"
          onClick={(e) => {
            Activity([
              {
                screen: "Truck-type Cleaning",
                module: "My Freight Benchmark",
                user_activity: `Location Screen: User clicked on Previous Button`,
                timestamp: currentRequestTimeStamp(),
              },
            ]);
            mixpanel.track(
              `Benchmark Location Screen: User has clicked on Previous Button`,
              {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: "LoRRI-Benchmark",
                ModuleName: "edit_page",
                ActivityLog: `UserHasClickedOnPreviousButton`,
                Data: `None`,
                Definition: `Benchmark Location Screen: User has clicked on Previous Button`,
                ActivityType: "event_view",
                UserName: `${localStorage.getItem("userdetails")}`,
                UserEmail: `${localStorage.getItem("useremail")}`,
                CompanyName: `${localStorage.getItem("companyname")}`,
              }
            );
            setPreviosStep(3);
            setStep(2);
          }}
        >
          Previous
        </button>
        <button
          className="btn btn-sm btn-primary"
          disabled={show}
          onClick={(e) => go_to_confirmpage()}
        >
          Next
        </button>
      </center>
    </div>
  );
};

export default TruckCleaning;
